import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class MollieConnectContainer extends Component {
  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("mollieAuths")
      .doc(this.props.user.uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          let mollieAuth = doc.data();
          const urlParams = new URLSearchParams(window.location.search);
          const code = urlParams.get("code");
          const randomState = urlParams.get("state");
          if (randomState === mollieAuth.randomState) {
            window.firebase
              .firestore()
              .collection("mollieAuths")
              .doc(this.props.user.uid)
              .update({ authCode: code })
              .then(() => {
                window.firebase
                  .auth()
                  .currentUser.getIdToken(true)
                  .then(function(token) {
                    fetch(
                      "https://tournify-server.herokuapp.com/createMollieToken",
                      {
                        method: "POST",
                        mode: "cors",
                        headers: {
                          Accept: "application/json, text/plain, */*",
                          "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                          idToken: token,
                          redirectURL: mollieAuth.redirectURL,
                          clientId: mollieAuth.clientId || ""
                        })
                      }
                    )
                      .then(function(response) {
                        return response.json();
                      })
                      .then(function(url) {
                        window.location = url.url;
                      });
                  })
                  .catch(function(err) {
                    console.error(err);
                  });
              });
          } else {
            window.location = mollieAuth.redirectURL;
          }
        }
      });
  };

  render() {
    return <div />;
  }
}

export default withRouter(MollieConnectContainer);
